/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ManualEnumerationInputDto } from './ManualEnumerationInputDto';
import {
    instanceOfManualEnumerationInputDto,
    ManualEnumerationInputDtoFromJSON,
    ManualEnumerationInputDtoFromJSONTyped,
    ManualEnumerationInputDtoToJSON,
} from './ManualEnumerationInputDto';
import type { ManualNumericInputDto } from './ManualNumericInputDto';
import {
    instanceOfManualNumericInputDto,
    ManualNumericInputDtoFromJSON,
    ManualNumericInputDtoFromJSONTyped,
    ManualNumericInputDtoToJSON,
} from './ManualNumericInputDto';

/**
 * @type ManualTaskWorkInputDto
 * 
 * @export
 */
export type ManualTaskWorkInputDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared' } & ManualEnumerationInputDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared' } & ManualNumericInputDto;


export function ManualTaskWorkInputDtoFromJSON(json: any): ManualTaskWorkInputDto {
    return ManualTaskWorkInputDtoFromJSONTyped(json, false);
}

export function ManualTaskWorkInputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualTaskWorkInputDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...ManualEnumerationInputDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...ManualNumericInputDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of ManualTaskWorkInputDto exists with '$type=${json['$type']}'`);
    }
}

export function ManualTaskWorkInputDtoToJSON(value?: ManualTaskWorkInputDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared':
            return ManualEnumerationInputDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared':
            return ManualNumericInputDtoToJSON(value);
        default:
            throw new Error(`No variant of ManualTaskWorkInputDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ManualTaskWorkInputDto interface.
 */
export function instanceOfManualTaskWorkInputDto(value: any): value is ManualTaskWorkInputDto {
    if (instanceOfManualEnumerationInputDto(value)) return true;
    if (instanceOfManualNumericInputDto(value)) return true;
    return false;
}

